import Cookies from 'js-cookie';
import { useEffect, useState } from 'react';
import css from './subscribe.module.scss';
import SubscriptionForm from 'src/components/subscribe/subscription-form';
import SuccesModal from './modals/succes-modal';

const SUBSCRIPTION_COOCKIE = 'subscription';

export default function SubscribeModal() {
  const [isShown, setIsShown] = useState(false);
  const [email, setEmail] = useState('');

  const handleAgree = () => {
    Cookies.set(SUBSCRIPTION_COOCKIE, 'true', { expires: 30 });
    setIsShown(false);
  };

  const handleSubscribe = (email: string) => setEmail(email);

  useEffect(() => {
    const consent = Cookies.get(SUBSCRIPTION_COOCKIE);
    if (!consent) {
      const timeoutId = setTimeout(() => {
        setIsShown(true);
      }, 600000);
      return () => clearTimeout(timeoutId);
    } else {
      setIsShown(false);
    }
  }, []);

  return (
    isShown && (
      <div className={css.subscriptionModal}>
        <button className={css.close} onClick={handleAgree}>
          &times;
        </button>
        <div className={css.container}>
          <h2>Підписуйтесь на оновлення платформи!</h2>
          <p>
            Підписуйтесь на оновлення платформи, щоб бути в курсі наших останніх оновлень та поповнень каталогу послуг
            та мапи зі знижками для військових та ветеранів
          </p>
          <div className={css.email}>
            <SubscriptionForm showText={false} onSubmit={handleSubscribe} />
            <SuccesModal
              isOpen={email.length > 0}
              email={email}
              onClose={() => {
                setEmail('');
                handleAgree();
              }}
            />
          </div>
        </div>
      </div>
    )
  );
}
